import angular from "angular";
import panel from "../services";

function swipeMatchScreen(panel){
  return {
    restrict: 'C',
    link: function(scope, element, attrs) {
      element = element[0];

      element.querySelector('.match-return-btn').addEventListener('click', function(){
        element.style.opacity = 0;
        element.style.zIndex = 0;
      });

      scope.$on('Liked', function(event, args) {
        element.style.zIndex = 999;
        element.style.opacity = 1;
      });
    }
  };
}

export default angular.module('directives.swipeMatchScreen', [panel]).directive('swipeMatchScreen', swipeMatchScreen).name;



// WEBPACK FOOTER //
// ./src/app/directives/swipeMatchScreen.js